export class ReimbursementFileUploadModel
{
    public TRDRefId : number;
    public ExpenseHeadId : number;
    public File :string;
    public Filename :string;
    public FileType : string;
    public FileExtension : string; 
    public Filesize : string;   
}  